/**
 * Стор темы оформления: тёмная / светлая.
 *
 * Выбор сохраняется в localStorage. При первом заходе уважает системную
 * тему (prefers-color-scheme). Применение — классом .theme-light на <html>.
 */
export type Theme = 'dark' | 'light';

const STORAGE_KEY = 'annotator:theme';
const LIGHT_CLASS = 'theme-light';

function initialTheme(): Theme {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'dark' || saved === 'light') return saved;
  return window.matchMedia?.('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
}

class ThemeStore {
  current = $state<Theme>('dark');
  private applied = false;

  init(): void {
    if (this.applied) return;
    this.current = initialTheme();
    this.apply();
    this.applied = true;
  }

  /** Применить текущую тему к DOM. */
  private apply(): void {
    const root = document.documentElement;
    root.classList.toggle(LIGHT_CLASS, this.current === 'light');
  }

  toggle(): void {
    this.set(this.current === 'dark' ? 'light' : 'dark');
  }

  set(theme: Theme): void {
    this.current = theme;
    this.apply();
    localStorage.setItem(STORAGE_KEY, theme);
  }
}

export const theme = new ThemeStore();
